import React, { useContext, useMemo } from 'react';

import { ItemsDisplayMode } from './config';
import type { ItemsDisplayModeEnumType } from './types';

type ContextType = {
  itemsDisplayMode: ItemsDisplayModeEnumType;
};

const defaultValue: ContextType = {
  itemsDisplayMode: ItemsDisplayMode.IconsTitles,
};

export const TabbarContext = React.createContext(defaultValue);
TabbarContext.displayName = 'TabbarContext';

export const useTabbarContext = () => useContext(TabbarContext);

export const TabbarContextProvider: React.FC<{
  itemsDisplayMode: ItemsDisplayModeEnumType;
  children: React.ReactNode;
}> = ({ itemsDisplayMode, children }) => {
  const value = useMemo(() => ({ itemsDisplayMode }), [itemsDisplayMode]);

  return <TabbarContext.Provider value={value}>{children}</TabbarContext.Provider>;
};
